import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeepDiveMultiComponent } from './deep-dive-multi.component';

const routes: Routes = [{ path: '', component: DeepDiveMultiComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeepDiveMultiRoutingModule { }
